<!-- App.svelte -->

<script>
    import { navigateTo } from 'svelte-router-spa'
    import TodoItem from "./components/TestItem.svelte";
    import { mmti_dict, pv } from "./store";

    let todos = [
        { id: 33, text: "관종입니다.", opacity: 1.0 },
        { id: 34, text: "아무래도 당신의 반려견은 천재인것 같습니다.", opacity: 1.0 },
        { id: 35, text: "집에 도착하면 열정적으로 뛰며 반기기보다는 조용히 와서 스쳐 지나갑니다.", opacity: 1.0 },
        { id: 36, text: "사료가 바뀌면 칼같이 바로 알아챕니다.", opacity: 1.0 },
        { id: 37, text: "가끔은 당신 말고 다른 사람도 너무 좋아해서 서운합니다.", opacity: 1.0 },
        { id: 38, text: "방금까지 하이텐션이다가 갑자기 삐지거나 우울해해서 종잡을 수 없습니다.", opacity: 1.0 },
        { id: 39, text: "간식이 눈 앞에 있어도 '기다려'하면 기다릴 수 있습니다.", opacity: 1.0 },
        { id: 40, text: "당신의 반려견은 당신의 말을 다 이해하고 있는 것 같습니다.", opacity: 0.0 },
    ];

    $pv = 32;
    let i = 0;
    let test_id = '';
    for (i = 0; i < todos.length; i++) {
        test_id = 'mmti' + String(todos[i].id)
        if (test_id in $mmti_dict) {
            $pv += 1;
        }
    } 


    function clickContinue() {
        let allPass = true;

        for (let i = 0; i < todos.length; i++) {
            let todo = todos[i];
            let test_id = 'mmti' + String(todo.id);

            if (test_id in $mmti_dict) {
                todos[i]['textColor'] = 'black';
                todos[i]['textAni'] = '';
            } else {
                allPass = false;
                todos[i]['textColor'] = '#ad1305';
                todos[i]['textAni'] = 'text_shake';

                setTimeout(function(){
                    todos[i]['textAni'] = '';
                }, 500);
            }
        }

        if (allPass) {
            navigateTo('result');
        } else {
            alert('체크 안 한 항목이 있는지 한 번 더 확인해주세요.');
        } 
    }

</script>

<style lang="scss">
.hero-body {
    background: #f5f5f6;   
}

body, html {
    -webkit-tap-highlight-color: transparent; 
}

.progress {
  border-radius: 0;
}

.progress.is-mmti::-webkit-progress-value {
  background-color: rgba($color: #36765a, $alpha: 1.0);
}

.progress.is-mmti::-moz-progress-bar {
  background-color:rgba($color: #36765a, $alpha: 1.0);
}

.progress.is-mmti::-ms-fill {
  background-color:rgba($color: #36765a, $alpha: 1.0);
}

.progress.is-mmti:indeterminate {
  background-image: linear-gradient(to right, rgba($color: #36765a, $alpha: 1.0) 30%, #ededed 30%);
}

</style>

<html class="has-navbar-fixed-top" style="padding-top: 0">

<nav class="navbar is-fixed-top" style="background: #f5f5f6; min-height: 0;">
<progress class="progress is-mmti" value="{$pv}" max="40"></progress>
</nav>


<body>
<section class="hero is-fullheight">
<div class="hero-body">
<div class="container has-text-centered">
<div class="columns is-desktop">

    <div class="column">

    {#each todos as todo (todo.id)}
    <TodoItem {todo} />
    {/each}

    <div class="container">
    <figure class="image container is-128x128" style="width: 150px; cursor: pointer;" on:click={() => clickContinue() }><img src="/next.png">
    <h1 class ="title is-6 is-overlay mt-4 mr-5 has-text-white"><p>다음</p></h1>
    </figure>
    </div>

</div>
</div>
</div>
</section>
</body>
</html>
